import { useForm } from './Form.h'

import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import FormTextField from '@shared/components/FormTextField'
import MotionDialog from '@shared/components/MotionDialog'
import { FormProvider } from 'react-hook-form'

export default function Form() {
    const {
        form,
        mutate,
        instance,
        handleClose
    } = useForm()

    return (
        <FormProvider {...form}>
            <MotionDialog
                onClose={handleClose}
                slotProps={{
                    paper: {
                        component: 'form',
                        onSubmit: form.handleSubmit(mutate)
                    }
                }}
            >
                <DialogTitle>{instance ? 'تعديل' : 'إضافة'}</DialogTitle>
                <DialogContent>
                    <FormTextField
                        name='name'
                        label='اسم المكتب'
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        variant='text'
                        onClick={handleClose}
                        disabled={form.isPending}
                    >إغلاق</Button>
                    <Button
                        variant='text'
                        type='submit'
                        disabled={form.isPending}
                    >حفظ</Button>
                </DialogActions>
            </MotionDialog>
        </FormProvider>
    )
}